// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"c5287ae6","239":"e4c542c7","433":"ec0bad8a","453":"3c0f562a","455":"f78fc3ed","977":"6f73ef3b"}[chunkId] + ".chunk.js";
};